import type { IconComponentType } from 'gcs-common/constants/IconConstants';
import Toggle from '../Toggle/Toggle';

interface MemberPermissionItemProps {
  title: string;
  Icon: IconComponentType;
  toggleEnabled: boolean;
  onToggle: (toogleValue: boolean) => void;
  testIdAttribute: string;
  disabled: boolean;
}

const MemberPermissionsItem = (props: MemberPermissionItemProps) => {
  const { title, Icon, toggleEnabled = false, onToggle, testIdAttribute = '', disabled = false } = props;

  return (
    <div className="flex h-12 flex-row items-center justify-self-stretch pl-3">
      <div className="flex items-center self-stretch pr-2">
        <Icon className="size-6 text-neutral-12" />
      </div>
      <div className="flex h-full w-full flex-row items-center border-0">
        <div className="flex shrink-0 grow flex-col items-start justify-center self-stretch justify-self-start">
          <div className="flex flex-row items-center space-x-2">
            <div> {title} </div>
          </div>
        </div>
        <div className="flex space-x-2 justify-self-end pr-2">
          <Toggle onClick={onToggle} isToggled={toggleEnabled} testIdAttribute={testIdAttribute} disabled={disabled} />
        </div>
      </div>
    </div>
  );
};

export default MemberPermissionsItem;
